<template>
  <component :is="currentComponent" />
</template>
<script lang="ts">
export default {
  name: 'YSelectArea'
}
</script>
<script lang="ts" setup>
import isMobile from '../../utils/is-mobile'
import MobileSelectArea from './selectAreaMobile.vue'
import PcSelectArea from './selectAreaPC.vue'
import { selectAreaProps } from './selectArea'

const judgeMobile = selectAreaProps.ipadAsPc ? isMobileSpecial() : isMobile()
const currentComponent = judgeMobile ? MobileSelectArea : PcSelectArea
function isMobileSpecial(): boolean {
  const u = navigator.userAgent
  const isNotIpad = u.indexOf('iPad') === -1
  // 特殊情况，判断ipad不属于移动端，需要展示pc端的ui和交互
  const mobile = (!!u.match(/AppleWebKit.*Mobile.*/) || u.indexOf('mqqbrowser') > -1) && isNotIpad
  return mobile
}
</script>
